import { types } from "../types/types";

const initialState = {
  compareResult: {}
};
export const compareResultReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case types.SEARCH_RESULT_START_REGISTER:
      return {
        ...state,
        compareResult: action.payload
      };

    default:
      return state;
  }
};